// LLM generated - Model Claude Opus 4.5
import { createStyles } from '@mantine/core';

import type { PayWithCreditsToggleVariant } from './types';

interface StyleParams {
  variant: PayWithCreditsToggleVariant;
}

const useStyles = createStyles((theme, { variant }: StyleParams) => {
  const isDark = variant === 'dark';

  return {
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      backgroundColor: isDark ? theme.colors.gray2[6] : theme.colors.gray2[0],
      borderRadius: theme.other.spacing._12,
      border: `1px solid ${isDark ? theme.colors.gray2[5] : theme.colors.gray2[0]}`,
      padding: `${theme.other.spacing._12}px ${theme.other.spacing._16}px`,
      width: '100%',
      cursor: 'pointer',
      transition: 'border-color 0.2s ease',

      '&:hover': {
        borderColor: isDark ? theme.colors.gray2[4] : theme.colors.gray2[1],
      },
    },

    containerDisabled: {
      opacity: 0.7,
      cursor: 'not-allowed',

      '&:hover': {
        borderColor: isDark ? theme.colors.gray2[5] : theme.colors.gray2[0],
      },
    },

    content: {
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
    },

    title: {
      color: isDark ? theme.white : theme.colors.gray2[6],
    },

    balance: {
      color: theme.colors.gray2[3],
    },

    balanceInsufficient: {
      color: theme.colors.red[3],
    },

    checkbox: {
      width: 20,
      height: 20,
      borderRadius: theme.other.spacing._4,
      border: `1px solid ${isDark ? theme.colors.gray2[4] : theme.colors.gray2[3]}`,
      backgroundColor: isDark ? theme.colors.gray2[5] : theme.white,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      transition: 'all 0.2s ease',
    },

    checkboxChecked: {
      backgroundColor: theme.colors.blue[7],
      borderColor: theme.colors.blue[7],
    },

    checkIcon: {
      color: theme.white,
      width: 14,
      height: 14,
    },

    insufficientMessage: {
      color: theme.colors.gray2[3],
      textAlign: 'right',
      whiteSpace: 'nowrap',
      flexShrink: 0,
    },

    voucherApplied: {
      color: theme.colors.gray2[3],
      textAlign: 'center',
      flexShrink: 0,
      maxWidth: 200,
      whiteSpace: 'pre-line',
    },
  };
});

export default useStyles;
